import { Injectable, inject, DOCUMENT } from '@angular/core';

import { BehaviorSubject } from 'rxjs';
import { Params } from '@angular/router';

@Injectable()
export class LinkService {
    private document = inject(DOCUMENT);

    currentPage$ = new BehaviorSubject<number>(1);

    createLinkTag(tag: string, href: string): void {
        if (this.exists(tag)) {
            this.updateLinkTag(tag, href);
        } else {
            const link: HTMLLinkElement = this.document.createElement('link');
            link.setAttribute('rel', tag);
            this.document.head.appendChild(link);
            link.setAttribute('href', href);
        }
    }

    exists(tagName: string): boolean {
        return this.document.querySelector(`link[rel=${tagName}]`) ? true : false;
    }

    deleteLinkTag(tag: string): void {
        this.document.querySelector(`link[rel=${tag}]`)?.remove();
    }

    updateLinkTag(tag: string, newUrl: string): void {
        this.document.querySelector(`link[rel=${tag}]`)?.setAttribute('href', newUrl);
    }

    getLinkTag(tag: string): string | null {
        return this.exists(tag) ? (this.document.querySelector(`link[rel=${tag}]`)?.getAttribute('href') ?? null) : null;
    }

    cleanUp(): void {
        if (this.exists('prev')) {
            this.deleteLinkTag('prev');
        }
        if (this.exists('next')) {
            this.deleteLinkTag('next');
        }
    }

    createOrUpdatePrevTag(prevPage: boolean, currentPage: number, url: string): void {
        if (!this.exists('prev')) {
            if (prevPage) {
                this.createLinkTag('prev', `${url}/${currentPage - 1}`);
            }
        }
        if (this.exists('prev')) {
            if (prevPage) {
                this.updateLinkTag('prev', `${url}/${currentPage - 1}`);
            } else {
                this.deleteLinkTag('prev');
            }
        }
    }

    createOrUpdateNextTag(nextPage: boolean, currentPage: number, url: string): void {
        if (!this.exists('next')) {
            if (nextPage) {
                this.createLinkTag('next', `${url}/${currentPage + 1}`);
            }
        }

        if (this.exists('next')) {
            if (nextPage) {
                this.updateLinkTag('next', `${url}/${currentPage + 1}`);
            } else {
                this.deleteLinkTag('next');
            }
        }
    }

    preparePageNumber(pageNumber: number | undefined, params: Params): void {
        pageNumber = parseInt(params['pageNumber']);
        if (pageNumber && !isNaN(pageNumber)) {
            this.currentPage$.next(pageNumber);
        } else {
            this.currentPage$.next(1);
        }
    }
}
